import { useState } from 'react';
import { useSessao } from '../../redux/sessao/sessaoHooks';
import { toast } from 'react-toastify';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Typography
} from '@mui/material';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import EdParticles from '../../Components/generic/EdParticles';
import FooterTelaLogin from '../../Components/generic/FooterTelaLogin';
import ModalCadastroUsuario from './ModalCadastroUsuario';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Loader from '../../Components/generic/Loader';
import LogoEmpresa from '../../Components/generic/LogoEmpresa';
import LockIcon from '@mui/icons-material/Lock';
import ModalRecuperarSenha from './ModalRecuperarSenha';

const LoginPage: React.FC = () => {
  const [, login] = useSessao();
  const [loading, setLoading] = useState(false);
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [verSenha, setVerSenha] = useState(false);
  const [openModalCadastro, setOpenModalCadastro] = useState(false);
  const [openModalEsqueceuSenha, setOpenModalEsqueceuSenha] = useState(false);

  const classes = useStyles();

  const onLogin = async () => {
    setLoading(true);

    try {
      await login(usuario, senha);
    } catch (err: any) {
      toast.error(err?.response?.data);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <EdParticles />

      <div className={classes.content}>
        <Paper className={classes.form} elevation={4} sx={{ borderRadius: 4 }}>
          <Box display="flex" justifyContent="center">
            <LogoEmpresa />
          </Box>

          <Typography variant="h5" align="center" gutterBottom>
            Área do Cliente
          </Typography>

          <TextField
            label="CPF / CNPJ"
            variant="outlined"
            value={usuario}
            onChange={(event) => setUsuario(event.target.value)}
            fullWidth
            disabled={loading}
            margin="normal"
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <AccountCircleIcon color="action" fontSize="small" />
                </InputAdornment>
              )
            }}
          />

          <TextField
            label="Senha"
            type={verSenha ? 'text' : 'password'}
            value={senha}
            onChange={(event) => setSenha(event.target.value)}
            onKeyPress={(event) => {
              if (event.key === 'Enter') onLogin();
            }}
            fullWidth
            disabled={loading}
            margin="normal"
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockIcon color="action" fontSize="small" />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="Mostrar ou ocultar senha"
                    onClick={() => setVerSenha(!verSenha)}
                    edge="end"
                  >
                    {verSenha ? <VisibilityIcon /> : <VisibilityOffIcon />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
          <Box textAlign="right">
            <Typography
              component="span"
              fontSize={12}
              sx={{ cursor: 'pointer', textDecoration: 'underline', color: 'primary.main' }}
              onClick={() => setOpenModalEsqueceuSenha(true)}
            >
              Esqueci minha senha
            </Typography>
          </Box>

          <Box mt={1} textAlign="center">
            {loading ? (
              <>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <Loader size={36} />
                </div>
              </>
            ) : (
              <Button onClick={onLogin} variant="contained" fullWidth sx={{ mb: 2, py: 1 }}>
                Entrar
              </Button>
            )}

            <Typography fontSize={14}>
              Novo por aqui?{' '}
              <Typography
                component="span"
                fontSize={14}
                sx={{ cursor: 'pointer', textDecoration: 'underline', color: 'primary.main' }}
                onClick={() => setOpenModalCadastro(true)}
              >
                Clique aqui para se cadastrar
              </Typography>
            </Typography>
          </Box>

          <FooterTelaLogin />
        </Paper>
      </div>

      {openModalCadastro && (
        <ModalCadastroUsuario
          open={openModalCadastro}
          onClose={() => setOpenModalCadastro(false)}
        />
      )}

      {openModalEsqueceuSenha && (
        <ModalRecuperarSenha
          open={openModalEsqueceuSenha}
          onClose={() => setOpenModalEsqueceuSenha(false)}
        />
      )}
    </div>
  );
};

export default LoginPage;

const useStyles = makeStyles((theme) =>
  createStyles({
    content: {
      display: 'flex',
      color: '#fff',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      position: 'absolute',
      minHeight: '100vh',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    },
    form: {
      background: '#fff',
      minWidth: 'min(350px, 95vw)',
      padding: '20px 20px 0 20px',
      display: 'flex',
      flexDirection: 'column'
    },
    buttonContainer: { display: 'flex', flexDirection: 'column', alignItems: 'center' },
    loaderContainer: { display: 'flex', justifyContent: 'center', marginBottom: '15px' },
    newAccountButton: {
      marginBottom: '20px',
      cursor: 'pointer',
      width: '100%',
      textAlign: 'center'
    }
  })
);
